module.exports = __webpack_public_path__ + "img/assuranceMaladie.4b12117e.png";